<template>
  <section class="news-events-section grey-bg">
    <div class="container">
      <div class="news-events-content">
        <SectionHeader :title="title" :extraClass="['side-image']" />
        <a-row :gutter="[32, 32]">
          <a-col
            :sm="12"
            :md="12"
            :lg="8"
            v-for="(item, index) in data"
            :key="index"
          >
            <Card :item="item" :index="index" :extraClass="['side-image']" />
          </a-col>
        </a-row>
        <div class="custom-button">
          <router-link v-if="archive.toLowerCase() === 'news'" to="news">
            Archives
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import Card from "@/pageComponents/globalUi/cards/event-card";
export default {
  name: "NewsEvents",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    archive: {
      type: String,
      default: ""
    }
  },
  components: {
    SectionHeader,
    Card
  },
  mounted() {},
  data() {
    return {
      list: this.data
    };
  }
};
</script>

<style lang="scss">
.news-events-section {
  .custom-button {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
}
</style>
